'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashOmit = require('lodash.omit');

var _lodashOmit2 = _interopRequireDefault(_lodashOmit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tcombReact = require('tcomb-react');

var _styleUtils = require('./styleUtils');

var _styleUtils2 = _interopRequireDefault(_styleUtils);

_tcombReact.t['interface'].strict = true;

var Props = {
  message: _tcombReact.t.maybe(_tcombReact.t.String),
  onAccept: _tcombReact.t.Function,
  link: _tcombReact.t.maybe(_tcombReact.t['interface']({
    msg: _tcombReact.t.maybe(_tcombReact.t.String),
    url: _tcombReact.t.String,
    target: _tcombReact.t.maybe(_tcombReact.t.enums.of(['_blank', '_self', '_parent', '_top', 'framename']))
  })),
  buttonMessage: _tcombReact.t.maybe(_tcombReact.t.String),
  closeIcon: _tcombReact.t.maybe(_tcombReact.t.String),
  disableStyle: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  styles: _tcombReact.t.maybe(_tcombReact.t.Object),
  className: _tcombReact.t.maybe(_tcombReact.t.String)
};

exports.Props = Props;
/** React Cookie banner template
 * @param message - message written inside default cookie banner
 * @param onAccept - called when user accepts cookies
 * @param link - object with infos used to render a link to your cookie-policy page
 * @param buttonMessage - message written inside the button of the default cookie banner
 * @param closeIcon - className passed to close-icon
 * @param disableStyle - pass `true` if you want to disable default style
 * @param styles - object with custom styles used to overwrite default ones
 */

var BannerContent = (function (_React$Component) {
  _inherits(BannerContent, _React$Component);

  function BannerContent() {
    var _this = this;

    _classCallCheck(this, _BannerContent);

    _React$Component.apply(this, arguments);

    this.getStyle = function (style) {
      var _props = _this.props;
      var disableStyle = _props.disableStyle;
      var styles = _props.styles;

      if (!disableStyle) {
        // apply custom styles if available
        return _extends({}, _styleUtils2['default'].getStyle(style), styles[style]);
      }
    };

    this.templateCloseIcon = function (_ref) {
      var className = _ref.className;
      var onClick = _ref.onClick;
      var style = _ref.style;
      return _react2['default'].createElement('i', { className: className, onClick: onClick, style: style });
    };

    this.templateCloseButton = function (_ref2) {
      var buttonMessage = _ref2.buttonMessage;
      var onClick = _ref2.onClick;
      var style = _ref2.style;
      return _react2['default'].createElement(
        'div',
        _extends({ className: 'button-close' }, { onClick: onClick, style: style }),
        buttonMessage
      );
    };

    this.templateLink = function (_ref3) {
      var link = _ref3.link;
      var style = _ref3.style;

      if (link) {
        var href = link.url;
        var target = link.target;
        var msg = link.msg;

        return _react2['default'].createElement(
          'a',
          _extends({ className: 'cookie-link' }, { href: href, target: target, style: style }),
          msg || 'Learn more'
        );
      }
    };
  }

  BannerContent.prototype.getLocals = function getLocals() {
    var getStyle = this.getStyle;
    var _props2 = this.props;
    var onAccept = _props2.onAccept;
    var className = _props2.className;
    var message = _props2.message;
    var link = _props2.link;
    var closeIcon = _props2.closeIcon;
    var buttonMessage = _props2.buttonMessage;

    var wrapperProps = _objectWithoutProperties(_props2, ['onAccept', 'className', 'message', 'link', 'closeIcon', 'buttonMessage']);

    return {
      message: message,
      cookieMessageStyle: getStyle('message'),
      wrapperProps: _extends({}, _lodashOmit2['default'](wrapperProps, Object.keys(Props)), {
        className: _classnames2['default']('react-cookie-banner', className),
        style: getStyle('banner')
      }),
      linkProps: {
        link: link,
        style: getStyle('link')
      },
      closeButtonProps: !closeIcon && {
        buttonMessage: buttonMessage,
        onClick: onAccept,
        style: getStyle('button')
      },
      closeIconProps: !!closeIcon && {
        className: closeIcon,
        onClick: onAccept,
        style: getStyle('icon')
      }
    };
  };

  BannerContent.prototype.render = function render() {
    var _getLocals = this.getLocals();

    var message = _getLocals.message;
    var cookieMessageStyle = _getLocals.cookieMessageStyle;
    var wrapperProps = _getLocals.wrapperProps;
    var linkProps = _getLocals.linkProps;
    var closeButtonProps = _getLocals.closeButtonProps;
    var closeIconProps = _getLocals.closeIconProps;

    return _react2['default'].createElement(
      'div',
      wrapperProps,
      _react2['default'].createElement(
        'span',
        { className: 'cookie-message', style: cookieMessageStyle },
        message,
        this.templateLink(linkProps)
      ),
      closeButtonProps && this.templateCloseButton(closeButtonProps),
      closeIconProps && this.templateCloseIcon(closeIconProps)
    );
  };

  _createClass(BannerContent, null, [{
    key: 'defaultProps',
    value: {
      buttonMessage: 'Got it',
      styles: {}
    },
    enumerable: true
  }]);

  var _BannerContent = BannerContent;
  BannerContent = _tcombReact.props(Props, { strict: false })(BannerContent) || BannerContent;
  return BannerContent;
})(_react2['default'].Component);

exports['default'] = BannerContent;


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/lib/BannerContent.js
// module id = 238
// module chunks = 114276838955818